import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import {
  VngButtonComponent,
  VngEmptyStateComponent,
  VngPillTabsComponent,
  VngSkeletonRowsComponent,
} from "@vengreso/angular-components";

import { AppNotificationService } from "src/app/core/core-services/services/app-notification.service";
import { AppNotification } from "src/app/core/models/notification.model";
import { NotificationItemComponent } from "../notification-item/notification-item.component";

const NOTIFICATION_STATE_TABS = ["Unread", "Read"] as const;

/**
 * The notification list — Unread/Read tabs, "Mark all as read",
 * infinite-scroll rows, loading skeleton and empty state. Content projected
 * into the notification drawer is recreated on every open. That deliberately
 * refreshes page 1; realtime push + unread-count polling stay owned by the
 * bell's long-lived `AppNotificationService`.
 */
@Component({
  selector: "app-notification-panel",
  standalone: true,
  imports: [
    CommonModule,
    InfiniteScrollModule,
    VngButtonComponent,
    VngEmptyStateComponent,
    VngPillTabsComponent,
    VngSkeletonRowsComponent,
    NotificationItemComponent,
  ],
  templateUrl: "./notification-panel.component.html",
  styleUrls: ["./notification-panel.component.scss"],
})
export class NotificationPanelComponent implements OnInit {
  readonly tabs = NOTIFICATION_STATE_TABS;
  activeTabIndex = 0;

  notifications$ = this.appNotificationService.notifications$;
  unreadCount$ = this.appNotificationService.unreadCount$;
  loading$ = this.appNotificationService.loading$;

  constructor(private readonly appNotificationService: AppNotificationService) {}

  ngOnInit(): void {
    this.appNotificationService.loadFirstPage({ unreadOnly: true });
  }

  onTabChange(index: number): void {
    this.activeTabIndex = index;
    this.appNotificationService.loadFirstPage(index === 1 ? { readOnly: true } : { unreadOnly: true });
  }

  onScrolled(): void {
    this.appNotificationService.loadMore();
  }

  onMarkAllRead(): void {
    this.appNotificationService.markAllRead();
  }

  trackById(_index: number, notification: AppNotification): string {
    return notification.id;
  }
}
